// import { useTranslation } from 'next-i18next';
// import Link from 'next/link'
// import { useRouter } from 'next/router'
import React, { useContext, useEffect, useState } from "react"
import DownloadBtn from "../common/DownloadBtn"
// import ProgressBar from 'react-progressbar-on-scroll'
// import { NavProgressContext } from '../context/navContext';
// import { slide as Menu } from "react-burger-menu"
// import SlidingMenuDesktop from '../common/Buttons/SlidingMenuDesktop';
// import Hamburger, { Fade } from "hamburger-react"
// import RoundedButton from '../common/Buttons/RoundedButton';
// import { motion, useViewportScroll, AnimatePresence } from 'framer-motion'
import { Link, NavLink, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { NavProgressContext } from "../context/navContext"
import { AnimatePresence, motion } from "framer-motion"
// import Image from 'next/image';
import {
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
} from "@chakra-ui/react"

function Navbar() {
	const [isMenuOpened, setMenuOpen] = useState(false)
	const location = useLocation()
	const asPath = location.pathname
	const [isMobile, setMobile] = useState(false)
	const isMobileHandler = (e) => {
		setMobile(e.matches)
	}

	useEffect(() => {
		window
			.matchMedia(`(max-width : 1023px)`)
			.addEventListener("change", isMobileHandler)
		setMobile(window.matchMedia(`(max-width : 1023px)`).matches)
	}, [])

	const handleMenu = () => {
		setMenuOpen(!isMenuOpened)
	}

	// Handling menu overflow in mobile
	useEffect(() => {
		if (isMenuOpened && isMobile) {
			window.document.body.style.overflow = "hidden"
		} else {
			window.document.body.style.overflow = "auto"
		}
	}, [isMenuOpened, isMobile])

	const { pageLoaded, setPageLoaded } = useContext(NavProgressContext)
	const { t, i18n } = useTranslation()

	useEffect(() => {
		setPageLoaded(true)
	}, [asPath, i18n.language])
	const changeLanguageHandler = (lang) => {
		i18n.changeLanguage(lang)
	}

	useEffect(() => {}, [i18n.language])

	// const [activeLink, setActiveLink] = useState(0);

	return (
		<div className="navbarSection">
			{
				// OLD MENU
				<div className={`menu ${isMenuOpened ? "menuOpened" : "menuClosed"} `}>
					<div className="menuItems">
						<div className="back-layer">
							<img
								src={
									process.env.PUBLIC_URL +
									"/imgs/home-page/statement-back-layer4.svg"
								}
								alt="back-layer"
							/>
						</div>
						{isMobile && (
							<div className="bg2">
								<img
									src={
										process.env.PUBLIC_URL +
										"/imgs/achievements/back-layer4.png"
									}
									alt=""
								/>
							</div>
						)}
						<div
							className={`navItem ${
								isMenuOpened ? "itemAppear" : "itemRemoval"
							}`}
							onClick={() => {
								setMenuOpen(false)
								window.scrollTo(0, 0)
							}}
						>
							<NavLink to={`/`} className="item home">
								<span>{t("navbar.home")}</span>
							</NavLink>
						</div>
						<div
							className={`navItem ${
								isMenuOpened ? "itemAppear" : "itemRemoval"
							}`}
							onClick={() => {
								setMenuOpen(false)
								window.scrollTo(0, 0)
							}}
						>
							<NavLink
								to={`/strategy`}
								className="item strategy"
								scroll={false}
							>
								<span className={`${({ isActive }) => isActive && "active"}`}>
									{t("navbar.strategy")}
								</span>
							</NavLink>
						</div>
						<div
							className={`navItem achievements ${
								isMenuOpened ? "itemAppear" : "itemRemoval"
							}`}
						>
							<Accordion allowMultiple className="item" key={isMenuOpened}>
								<AccordionItem>
									<AccordionButton
										className={`${
											asPath.includes("/achievements") && "active-panel"
										}`}
									>
										<div>{`${t("navbar.achievements")}`}</div>
										<AccordionIcon />
									</AccordionButton>
									<AccordionPanel pb={4}>
										<NavLink
											to={`/achievements/services`}
											className="services"
											scroll={false}
										>
											<span
												onClick={() => {
													setMenuOpen(false)
												}}
												className={` ${({ isActive }) => isActive && "active"}`}
											>
												{t("footer.services_mobile")}
											</span>
										</NavLink>
										<NavLink
											to={`/achievements/people`}
											className="people"
											scroll={false}
										>
											<span
												onClick={() => {
													setMenuOpen(false)
												}}
												className={` ${({ isActive }) => isActive && "active"}`}
											>
												{t("footer.people_mobile")}
											</span>
										</NavLink>
										<NavLink
											to={`/achievements/community`}
											className="community"
											scroll={false}
										>
											<span
												onClick={() => {
													setMenuOpen(false)
												}}
												className={` ${({ isActive }) => isActive && "active"}`}
											>
												{t("footer.community_mobile")}
											</span>
										</NavLink>
										<NavLink
											to={`/achievements/environment`}
											className="environment"
											scroll={false}
										>
											<span
												onClick={() => {
													setMenuOpen(false)
												}}
												className={` ${({ isActive }) => isActive && "active"}`}
											>
												{t("footer.environment_mobile")}
											</span>
										</NavLink>
									</AccordionPanel>
								</AccordionItem>
							</Accordion>
						</div>
						<div
							className={`navItem ${
								isMenuOpened ? "itemAppear" : "itemRemoval"
							}`}
							onClick={() => {
								setMenuOpen(false)
								window.scrollTo(0, 0)
							}}
						>
							<NavLink to={`/our-awards-and-certifications`} className="item appendices">
								<span className={`${({ isActive }) => isActive && "active"}`}>
									{t("navbar.appendices")}
								</span>
							</NavLink>
						</div>
						{isMobile && (
							<div
								className={`btns mobileBtns navItem ${
									isMenuOpened ? "itemAppear" : "itemRemoval"
								}`}
							>
								{i18n.language === "en" && (
									<div
										className="langBtn"
										onClick={() => {
											changeLanguageHandler("ar")
											setMenuOpen(false)
										}}
									>
										<DownloadBtn arabic text={"العربية"} gold outlined />
									</div>
								)}
								{i18n.language === "ar" && (
									<div
										className="langBtn"
										onClick={() => {
											changeLanguageHandler("en")
											setMenuOpen(false)
										}}
									>
										<DownloadBtn english text={"English"} gold outlined />
									</div>
								)}
								<DownloadBtn
									text={t("navbar.download")}
									gold
									pdfPath={
										i18n.language === "ar"
											? process.env.PUBLIC_URL +
											  "/Ajman-Municipality-Sustainability-Report-2022A.pdf"
											: process.env.PUBLIC_URL +
											  "/Ajman-Municipality-Sustainability-Report-2022.pdf"
									}
								/>
							</div>
						)}
					</div>

					{!isMobile && (
						<div className="menuRightSection">
							<div
								className={`quote ${
									isMenuOpened ? "itemAppear" : "itemRemoval"
								}`}
							>
								&quot;{t("navbar.quote")}&quot;
							</div>

							<div
								className={`btns ${
									isMenuOpened ? "itemAppear" : "itemRemoval"
								}`}
							>
								{/* {(i18n.language === "en" || i18n.language === "en-US") && (
									<div
										className="lang-btn-container"
										onClick={() => {
											setMenuOpen(false)
											window.scrollTo(0, 0)
											changeLanguageHandler("ar")
											setPageLoaded(false)
										}}
									>
										<NavLink to={asPath}>
											<DownloadBtn arabic text={"العربية"} gold outlined />
										</NavLink>
									</div>
								)}
								{i18n.language === "ar" && (
									<div
										className="lang-btn-container english"
										onClick={() => {
											setMenuOpen(false)
											window.scrollTo(0, 0)
											changeLanguageHandler("en")
											setPageLoaded(false)
										}}
									>
										<NavLink to={asPath} locale={"en"} passHref>
											<DownloadBtn english text={"ENGLISH"} gold outlined />
										</NavLink>
									</div>
								)} */}
								<div
									onClick={() => {
										setMenuOpen(false)
										window.scrollTo(0, 0)
										changeLanguageHandler(i18n.language === "ar" ? "en" : "ar")
										setPageLoaded(false)
									}}
								>
									<DownloadBtn
										text={i18n.language === "en" ? "العربية" : "English"}
										gold
										outlined
										arabic={i18n.language === "en" && true}
										english={i18n.language === "ar" && true}
									/>
								</div>
								<div>
									<DownloadBtn
										text={t("navbar.download")}
										gold
										pdfPath={
											i18n.language === "ar"
												? process.env.PUBLIC_URL +
												  "/Ajman-Municipality-Sustainability-Report-2022A.pdf"
												: process.env.PUBLIC_URL +
												  "/Ajman-Municipality-Sustainability-Report-2022.pdf"
										}
									/>
								</div>
							</div>
						</div>
					)}
				</div>

				// NEW MENU
				// <div className={`menu ${isMenuOpened ? 'menuOpened' : 'menuClosed'} `}>
				//   <div className='menuItems'>
				//     <div onMouseEnter={() => {setActiveLink(0)}} className={`navItem ${isMenuOpened ? 'itemAppear' : 'itemRemoval'}`} onClick={() => {setMenuOpen(false); window.scrollTo(0,0);}}>
				//       <div className={`arrow-container ${activeLink === 0 ? 'show' : 'hide'}`}>
				//         <img src={process.env.PUBLIC_URL + "/imgs/menuArrow.svg"} alt="" />
				//       </div>
				//       <NavLink to={`/`} className="item">
				//         <span className={`${({ isActive }) => isActive && 'active'}`}>{t('navbar.home')}</span>
				//       </NavLink>
				//     </div>
				//     <div onMouseEnter={() => {setActiveLink(1)}} className={`navItem ${isMenuOpened ? 'itemAppear' : 'itemRemoval'}`} onClick={() => {setMenuOpen(false); window.scrollTo(0,0)}}>
				//     <div className={`arrow-container ${activeLink === 1 ? 'show' : 'hide'}`}>
				//         <img src={process.env.PUBLIC_URL + "/imgs/menuArrow.svg"} alt="" />
				//       </div>
				//       <NavLink  to={`/strategy`} className="item" scroll={false} >
				//         <span className={`${({ isActive }) => isActive && 'active'}`}>{t('navbar.strategy')}</span>
				//       </NavLink>
				//     </div>
				//     <div onMouseEnter={() => {setActiveLink(2)}} className={`navItem ${isMenuOpened ? 'itemAppear' : 'itemRemoval'}`} onClick={() => {setMenuOpen(false); window.scrollTo(0,0)}}>
				//     <div className={`arrow-container ${activeLink === 2 ? 'show' : 'hide'}`}>
				//         <img src={process.env.PUBLIC_URL + "/imgs/menuArrow.svg"} alt="" />
				//       </div>
				//       <NavLink to={`/achievements`} className="item" scroll={false}>
				//         <span className={` ${({ isActive }) => isActive && 'active'}`}>
				//           {t('navbar.achievements')}
				//         </span>
				//       </NavLink>
				//     </div>
				//     <div onMouseEnter={() => {setActiveLink(3)}} className={`navItem ${isMenuOpened ? 'itemAppear' : 'itemRemoval'}`} onClick={() => {setMenuOpen(false); window.scrollTo(0,0)}}>
				//     <div className={`arrow-container ${activeLink === 3 ? 'show' : 'hide'}`}>
				//         <img src={process.env.PUBLIC_URL + "/imgs/menuArrow.svg"} alt="" />
				//       </div>
				//       <NavLink to={`/our-awards-and-certifications`} className="item">
				//         <span className={`${({ isActive }) => isActive && 'active'}`}>
				//         {t('navbar.appendices')}
				//           </span>
				//       </NavLink>
				//   </div>
				//   <div className={`btns ${isMenuOpened ? 'itemAppear' : 'itemRemoval'}`}>
				//         <DownloadBtn text={t('navbar.download')} navMenu gold navLang/>
				//         {(i18n.language === 'en' || i18n.language === 'en-US') &&
				//           <div className='lang-btn-container' onClick={() => {setMenuOpen(false); window.scrollTo(0,0); changeLanguageHandler('ar'); setPageLoaded(false)}}>
				//               <NavLink to={asPath}>
				//                 <DownloadBtn arabic text={'العربية'} gold outlined navLang/>
				//               </NavLink>
				//           </div>
				//         }
				//         {i18n.language === 'ar' &&
				//           <div className='lang-btn-container english' onClick={() => {setMenuOpen(false); window.scrollTo(0,0); changeLanguageHandler('en'); setPageLoaded(false)}}>
				//           <NavLink to={asPath} locale={"en"} passHref>
				//               <DownloadBtn english text={'ENGLISH'} gold outlined navLang/>
				//           </NavLink>
				//             </div>
				//         }
				//       </div>
				//     {isMobile &&
				//       <div className={`btns mobileBtns navItem ${isMenuOpened ? 'itemAppear' : 'itemRemoval'}`}>
				//           <DownloadBtn text={t('navbar.download')} navMenu gold navLang/>
				//         {i18n.language === 'en' &&
				//           // <NavLink to={asPath} locale={"ar"} passHref>
				//             <div className='langBtn' onClick={() => {window.scrollTo(0,0); changeLanguageHandler('ar')}}>
				//               <DownloadBtn arabic text={'العربية'} gold outlined navLang/>
				//             </div>
				//           // </NavLink>
				//         }
				//         {i18n.language === 'ar' &&
				//           // <NavLink to={asPath} locale={"en"} passHref>
				//             <div className='langBtn' onClick={() => {window.scrollTo(0,0); changeLanguageHandler('en')}}>
				//               <DownloadBtn english text={'ENGLISH'} gold outlined navLang/>
				//             </div>
				//           // </NavLink>
				//         }
				//       </div>
				//     }
				//   </div>
				//   {activeLink !== 2 &&
				//   // <AnimatePresence exitBeforeEnter={true}>
				//     <div
				//     // initial={{ opacity: 0 }}
				//     // whileInView={{ opacity: 1 }}
				//     // viewport={{ once: false }}
				//     // transition={{ ease: "easeInOut", delay: 5, duration: 0.5 }}
				//     className={`img-container ${isMenuOpened ? 'imgAppear' : 'imgRemoval'}`}>
				//         <img

				//         src={process.env.PUBLIC_URL + menuImgs[activeLink]} alt="banner_img" />
				//     </div>
				//       // </AnimatePresence>
				//   }
				//   {activeLink === 2 &&
				//     <div className="achievemnts-list">
				//       <ul>
				//         {achievementsList.map((item, index) => (
				//           <li key={index}>
				//             <NavLink to={`/our-awards-and-certifications`} className="item" >
				//               {item}
				//             </NavLink>
				//             </li>
				//         ))}
				//       </ul>
				//     </div>
				//   }
				//     <div className="back-layer1">
				//       <img src={process.env.PUBLIC_URL + '/imgs/home-page/banner-back-layer1.svg'} alt="back-layer" />
				//     </div>
				//     <div
				//     className="back-layer2">
				//       <img src={process.env.PUBLIC_URL + '/imgs/home-page/banner-back-layer2.svg'} alt="back-layer" />
				//     </div>
				// </div>
			}

			<nav
				className={`navbar navbar-expand-lg navbar-light bg-light w-100 ${
					pageLoaded ? "filledProgress" : ""
				}`}
			>
				<a
					className="navbar-brand"
					href="https://www.am.gov.ae/"
					target="_blank"
					rel="noreferrer"
				>
					<div className="logoContainer">
						<img
							src={process.env.PUBLIC_URL + `/imgs/home-page/logo.png`}
							alt="ajman_municipality_logo"
						/>
					</div>
				</a>
				<div
					className={`menuBtn ${isMenuOpened ? "menuClosing" : ""}`}
					onClick={() => {
						handleMenu()
					}}
				>
					<div className="menuBtnContainer">
						<div className="topLine"></div>
						<div className="middleLine"></div>
						<div className="bottomLine"></div>
					</div>
				</div>
			</nav>
		</div>
	)
}

export default Navbar
